import React, { FC } from "react";
import useGlobalModel from "@/model/globalModel";

export interface IYhAuth {
    resCode: string;
    isShow?: boolean;  //强制渲染， 不去查询是否具有用户权限。
}


export const YhAuth: FC<IYhAuth> = (props) => {
    const { resourceAuth } = useGlobalModel(model => [model.resourceAuth])
    const hasAuth = (resCode: string, isShow: boolean | undefined): boolean => {
        if (isShow) return true;
        //判断当前用户是否具有资源访问权限
        return !!resourceAuth.find(item => item === resCode);
    }
    const { resCode, isShow, children } = props
    return hasAuth(resCode, isShow) ? <>{children}</> : null
}